module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/banner/vi-192d5ee1bff749472ef3faee586d996e.jpg";